import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

export const ServicesMinimumSpendInfo = () => (
	<output
		className={Styles.minimumSpendInfo}
		aria-live="polite"
		aria-atomic="true"
	>
		<Icon size="sm" name="info" aria-label="Information" color="dark" />
		<TextBody size="xs" asTyped>
			Please select at least one more service to continue.
		</TextBody>
	</output>
);
